module.exports = __webpack_public_path__ + "static/img/14000053.bc8d098e.png";